import { HomeExamResultPage } from './HomeExamResultPage';
export default HomeExamResultPage;
